import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { IPortfolio } from '../types';
import { PortfolioRow } from './portfolio-row';

interface Props {
  tableProps: TableProps;
  rows?: IPortfolio[];
  loading?: boolean;
  canAddPortfolio?: string;
}

const PortfolioList = ({ tableProps, rows, loading, canAddPortfolio }: Props) => {
  const TABLE_HEAD = [
    { id: 'id', label: 'Id', align: 'center' },
    { id: 'title', label: 'Title', align: '' },
    { id: 'description', label: 'Description', align: 'center', sortable: false },
    { id: 'category', label: 'Category', align: 'center' },

    ...(canAddPortfolio
      ? [{ id: 'Action', label: 'Action', align: 'center', sortable: false }]
      : []),
  ];
  return (
    <PaginatedTable<IPortfolio>
      head={TABLE_HEAD}
      tableProps={tableProps}
      data={rows}
      loading={loading}
      isServerSidePaging={false}
    >
      {(row) => (
        <PortfolioRow
          row={row}
          canAddPortfolio={canAddPortfolio}
          selected={tableProps.selected.includes(row.id)}
          onSelectRow={() => {
            ('');
          }}
        />
      )}
    </PaginatedTable>
  );
};
export { PortfolioList };
